import React from "react";
import { Link } from "react-router-dom";
import { handleDateWithMonth, handleTime } from "../../utils/formatdate";

interface IFeedListProps {
  figId: string;
  figName: string;
  content: React.ReactNode;
  date: Date;
  className?: string;
  onClick: () => void;
}

const FeedList: React.FC<IFeedListProps> = ({
  figId,
  figName,
  content,
  date,
  className,
  onClick,
}) => {
  return (
    <div
      className={`row align-items-center feed-section-details m-0 ${className}`}
      onClick={onClick}
    >
      <div className="col-lg-3">
        <span className="name">
          <Link
            to={{
              pathname: `/${figId}`,
            }}
            className="text-decoration-none purple-color text-start font-18 font-500"
            onClick={(e) => e.preventDefault()}
          >
            {figName}
          </Link>
        </span>
      </div>
      <div className="col-lg-6">
        {/* Replace <p> with <div> */}
        <div className="detail">{content}</div>
      </div>
      <div className="col-lg-3 text-right">
        <div className="date-section">
          <div>
            {handleDateWithMonth(
              `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            )}
          </div>
          <div>
            {handleTime(
              `${date.getHours()}:${date.getMinutes().toString().length === 1
                ? `0${date.getMinutes()}`
                : date.getMinutes()}`
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedList;
